var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", {
    attrs: {
      width: "calc(100% - 32px)",
      "max-width": "420px",
      "body-class": "p-3",
    },
    on: { hide: _vm.hideModal },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("h5", { staticClass: "modal-title" }, [
              _vm._v("Cambiar contraseña"),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "el-form",
              {
                ref: "general",
                staticClass: "form-compacto",
                attrs: {
                  model: _vm.general,
                  rules: _vm.rules,
                  "label-position": "top",
                  size: "mini",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "password", label: "Nueva contraseña" } },
                  [
                    _c("el-input", {
                      attrs: { type: "password", "show-password": "" },
                      model: {
                        value: _vm.general.password,
                        callback: function ($$v) {
                          _vm.$set(_vm.general, "password", $$v)
                        },
                        expression: "general.password",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.hideModal },
              },
              [_vm._v(" Cancelar ")]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.editedpassword("general")
                  },
                },
              },
              [_vm._v(" Aceptar ")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }